import { selectPlaceShowDifferentSizeOnMap } from 'containers/MapDetails/placeSlice'
import { selectPlaygroundWarehouses } from './playgroundSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import useTranslation from 'hooks/useTranslation'
import { useReduxSelector } from 'store'
import React from 'react'

const Legend: React.FC = () => {
  const userId = useReduxSelector(selectUserId)
  const warehouses = useReduxSelector(selectPlaygroundWarehouses)
  const isAnyWarehouseRented = checkIsAnyWarehouseIsRented(warehouses, userId)
  const showDifferentSize = useReduxSelector(selectPlaceShowDifferentSizeOnMap)
  const { t } = useTranslation('placeMap')

  return (
    <div className='placeMap__playground__legend__wrapper'>
      <h5>{t('legend')}:</h5>
      <div className='placeMap__playground__legend'>
        <div className='placeMap__playground__legend__item --selected'>
          {t('selected')}
        </div>
        {isAnyWarehouseRented && <div
          className='placeMap__playground__legend__item'
          style={{
            backgroundColor: 'rgba(70, 40, 149, 0.1)',
            borderColor: 'rgba(70, 40, 149, 1)',
            color: 'rgba(70, 40, 149, 1)'
          }}>
          {t('user')}
        </div>}
        <div className='placeMap__playground__legend__item --available'>
          {t('available')}
        </div>
        {showDifferentSize && <div className='placeMap__playground__legend__item --differentSize'>
          {t('differentSize')}
        </div>}
        <div className='placeMap__playground__legend__item --unavailable'>
          {t('unavailable')}
        </div>
      </div>
    </div>
  )
}

const checkIsAnyWarehouseIsRented = (warehouses?: playground.Warehouse[], userId?: string) => {
  if (warehouses && warehouses.length > 0 && userId) {
    for (const warehouse of warehouses) {
      if (warehouse.warehouseData?.renting?.clientId === userId) {
        return true
      } else if (warehouse.children && warehouse.children.length > 0) {
        const isRent = checkIsAnyWarehouseIsRented(warehouse.children, userId)
        if (isRent) return true
      }
    }
  }

  return false
}

export default Legend